module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-friend"
  }, [_c('span', {
    staticClass: "material-icons remove",
    on: {
      "click": function($event) {
        return _vm.onClickRemove(_vm.item)
      }
    }
  }, [_vm._v("cancel")]), _c('div', {
    staticClass: "img-avt"
  }, [(_vm.item.avatar) ? _c('img', {
    attrs: {
      "src": _vm.item.avatar
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/images/faces/ic_AvatarDefault.svg")
    }
  })]), _c('div', {
    staticClass: "fullname"
  }, [_vm._v(_vm._s(_vm.item.fullname || 'default'))]), _c('div', {
    staticClass: "list-link"
  }, [_c('button', {
    staticClass: "dropdown relation-dropdown"
  }, [_c('div', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [(_vm.item.type === 1) ? _c('span', {
    domProps: {
      "textContent": _vm._s('Bạn bè')
    }
  }) : (_vm.item.type === 2) ? _c('span', {
    domProps: {
      "textContent": _vm._s('Bạn đồng hành')
    }
  }) : (_vm.item.type === 3) ? _c('span', {
    domProps: {
      "textContent": _vm._s('Giáo viên')
    }
  }) : _c('span', {
    domProps: {
      "textContent": _vm._s('Default')
    }
  }), _c('div', {
    staticClass: "material-icons"
  }, [_vm._v("signal_cellular_4_bar")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38d8f582","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Member/templateInfo.vue
// module id = 1533
// module chunks = 0